import { throttle } from 'throttle-debounce';
import { getScrollY } from '../helpers/utilify';

/**
 * スクロールされたらtoggleClassNameを付与
 *
 * @param {HTMLElement} targetElm
 * @param { { onScroll: (scrollY: number) => unknown; immediate: boolean; toggleClassName?: string; delay: number; } } options?
 */
export default function toggleClassOnScroll(targetElm, options = {}) {
  if (!targetElm) return;

  const toggleClassName = options.toggleClassName || 'is-visible';
  const delay = options.delay || 500;

  const onScroll = () => {
    const scrollY = getScrollY();

    if (scrollY > 0) {
      targetElm.classList.add(toggleClassName);
    } else {
      targetElm.classList.remove(toggleClassName);
    }
    if (typeof options.onScroll === 'function') {
      options.onScroll(scrollY);
    }
  };

  const onScrollHandler = throttle(delay, onScroll);

  window.addEventListener('scroll', onScrollHandler, false);

  if (options.immediate) {
    onScroll();
  }

  return {
    disconnect: () => window.removeEventListener('scroll', onScrollHandler),
  };
}
